import { gql } from 'graphql-request'

export const updateUserName = gql`
  mutation Mutation($meInput: UpdateMeInput!) {
    updateMe(meInput: $meInput) {
      id
      firstName
      lastName
    }
  }
`

export const updateEmail = gql`
  mutation Mutation($meInput: UpdateMeInput!) {
    updateMe(meInput: $meInput) {
      id
      email
    }
  }
`

export const updateProfileImage = gql`
  query UpdateProfileImage($format: ImageFileVersionFormat!) {
    me {
      updateProfileImage(input: { format: $format }) {
        tempUrl
        requestedBy
        userType
      }
    }
  }
`

export const deleteProfileImage = gql`
  mutation DeleteProfileImage {
    deleteMyProfileImage
  }
`

export const invalidateProfileImageCache = gql`
  mutation InvalidateProfileImageCache {
    invalidateProfileImageCache
  }
`
